export const LINE_WIDTH = 3;
export const HORIZONTAL_OFFSET = 8.25;
export const VERTICAL_OFFSET = 8.45;
export const DISTANCE_FROM_TOP_TO_CENTER_OF_INDICATOR = 12;
